import React from 'react'; 
import i18n from "i18next";
import { Button, Tooltip, Row, Col, Modal, Tabs, message } from 'antd';
import { CloseOutlined, CreditCardOutlined, EditOutlined, FileAddOutlined, 
  AppstoreAddOutlined, LinkOutlined, DeleteOutlined, RollbackOutlined,
  FileZipOutlined, InfoCircleOutlined, FileSyncOutlined } from '@ant-design/icons'
import { LoadingComponent } from '../../utils/ui'
import { getNameAsset } from '../../components/adms/helper';
import ConceptSchemeData from '../../components/skos/ConceptSchemeData';
import { SkosRepository, SkosScheme, ModelViews, RdfTriplet} from '../../redux';
import { DetailLinkScheme } from '../../components/adms/DetailLinkCard';
import SelectProperty from '../../components/widgets/SelectProperty';
import ViewsProxy from '../models/ViewsProxy';
import ConceptsInSchemeCard from './InSchemeCard';
import NewElement from '../../components/editor/NewElement';
import { makeHashLastInURI, makeURI } from '../../utils/uriUtil';
import { getCountValue } from '../../virtuoso/helper';
import SelectConcept from '../../components/skos/SelectConcept';
import ConceptCard from './ConceptCard';
import ConceptSchemeUsed from '../../components/skos/ConceptSchemeUsed';
import { SubjectListView } from '../containers';
import { filterAddedPredicates } from '../helper';
import ExportConceptScheme from '../../components/export/ExportConceptScheme';
import SynchronizationConceptScheme from '../../components/export/SynchronizationConceptScheme';
import DeleteScheme from '../../components/skos/DeleteScheme';
import ConeptUriReplacement from '../../components/skos/ConeptUriReplacement';
import settings from '../../virtuoso/settings';

const ButtonGroup = Button.Group;
const { confirm } = Modal;
const { TabPane } = Tabs;

const AssetTitle = names => {
    const single = names.length = 1;
    return (single)? names[0]: <span>names.map(name => <p>{name}</p>)</span>;
}

/**
 * 
 * @param {*} formRef 
 * @param {*} IRI - текущий выбранный элемент (IRI)
 * @param {*} factory - фабрика получения информкции о списка доступных свойств и их аннотации
 * @param {*} existing - массив существующих у объекта свойств (предикат + объекта)
 * @param {*} lang  - текущий язык
 * @param {*} onFinishOperation - callback для добавления
 * @param {*} onCancelOperation - callback для отмены
 * @returns 
 */
const showAddProperty = (formRef=f=>f, IRI, existing, factory, lang, 
  onFinishOperation=f=>f, onCancelOperation=f=>f) => {
  return <Modal style={{minWidth: "80%"}} open={true} title={i18n.t('views.skos.schemeCard.addProperty')} cancelText={i18n.t('views.skos.common.cancel')} okText={i18n.t('views.skos.common.ok')}
		onCancel={onCancelOperation} onOk={onFinishOperation}
    destroyOnHidden>
        <SelectProperty formRef={formRef} subjectIri={IRI} existing={existing} 
          factory={factory} lang={lang}/>      
        {/* <AddPropertyForm formRef={formRef} IRI={IRI} existing={existing}         
          factory={factory} rdfType="http://www.w3.org/2004/02/skos/core#ConceptScheme" lang={lang}
          onChange={onSelectNewProperty}/> */}
	  </Modal>
}

/** Показ диалога с детальной информацией об элементе  */
const showViewDetail = (formRef=f=>f, selected, factory, lang, onFinishOperation=f=>f, onCancelOperation=f=>f) => {
	//console.log("syncPercent", syncPercent);
	return <Modal style={{minWidth: "80%"}} open={true} title={i18n.t('views.skos.schemeCard.details')} cancelText={i18n.t('views.skos.common.cancel')} okText={i18n.t('views.skos.common.close')}
		onCancel={onCancelOperation} onOk={onFinishOperation}	cancelButtonProps={{ disabled: true, style: { display: "none" } }}
    destroyOnHidden>
        <DetailLinkScheme triplet={selected} factory={factory}/>
	  </Modal>
}

/** Показ диалога со списком связанных субъектов. iri - iri объекта для которого 
 * необходимо получить информацию о субъектах */
const showUsed = ( iri, factory,  onFinishOperation=f=>f) => {
  /** Сформировать условия для отбора или снятия отбора  */
  const rfilter = [{
    predicate: "http://www.w3.org/ns/dcat#theme", operator: "=", value: iri, 
    alias:"theme", 
    label:iri,
    type: "uri",
    scheme: "http://www.w3.org/1999/02/22-rdf-syntax-ns#type",
    //Переменная, к которой используется условие. см. addAliasInWhere в virtuoso/filter.js
    variable: "subject"
  }];

	return <Modal style={{minWidth: "80%"}} open={true} title={i18n.t('views.skos.schemeCard.usedBy')} okText={i18n.t('views.skos.common.close')}
		onCancel={onFinishOperation} onOk={onFinishOperation}	cancelButtonProps={{ disabled: true, style: { display: "none" } }}
    destroyOnHidden>
        <SubjectListView iri={iri} factory={factory} rfilter={rfilter} />
	  </Modal>
}

const decodeIRIParams = router =>{
  return (router && router.params && router.params.id)?decodeURIComponent(router.params.id):null;
}

/** Покзать диалог, который используется для установки связи с классификатором */
const showLink = (factory, onFinishOperation=f=>f, onCancelOperation=f=>f, linkInScheme=f=>f) => {
	return <Modal 
          style={{minWidth: "80%"}} open={true} title={i18n.t('views.skos.schemeCard.selectConcept')} cancelText={i18n.t('views.skos.common.cancel')} okText={i18n.t('views.skos.common.ok')}
          onCancel={onCancelOperation} onOk={onFinishOperation}	cancelButtonProps={{ style: { display: "none" } }}
          destroyOnHidden>
            <SelectConcept factory={factory} 
              loadConcepts={SkosRepository.loadConcepts} 
              loadNotInSchemeConcepts={SkosRepository.loadNotInSchemeConcepts}
              loadLabels={SkosRepository.loadLabels}
              onSelect={({ uri, labels }) => {
                linkInScheme(uri)
                console.log(uri, labels);
              }}
            />
          </Modal>
}

/**
 * Отобразить диалог для создания нового концепта.
 * Варианты заполнение:
 * 1. Формирование URI на основе URI схемы с добавлением #Concept+Текущая дата и время
 *    Выбор элемента как корневого
 *    Выбор более общего концепта
 * 
 * Проверка на основе двух полей (accessURL и downloadURL)
 * https://stackoverflow.com/questions/70067400/manually-validate-antd-form-field-against-another-field
 * 
 * graph - iri графа, который содержит данные
 */
const showNew = (formRef=f=>f, factory, onFinishOperation=f=>f, onCancelOperation=f=>f, schemeURI, concepts=[]) => {
  const extra =[
    //см. http://www.w3.org/2004/02/skos/core#topConceptOf
    { "uri": "new.flag.boolean", 
      rules: [
        { required: false, message: i18n.t('views.skos.schemeCard.rootFlagHelp') },
        (formInstance) => ({
          message: i18n.t('views.skos.schemeCard.rootOrBroaderRequired'),
          validator: async (_, value) => {
            const broader = formInstance.getFieldValue("new.select.uri");
            //console.log("11111111111", value, broader, value && broader && broader.length > 6)
            if ((!broader || broader.length === 0) && !value){
              return Promise.reject(new Error());
             }
            if (value && broader && broader.length > 6)
              return Promise.reject(new Error());
            return Promise.resolve();
          },
        }),
        { type: 'boolean', warningOnly: true },
      ],
      "label": i18n.t('views.skos.schemeCard.rootInScheme'),
      defaultChecked: true
    },
    //http://www.w3.org/2004/02/skos/core#broader
    { "uri": "new.select.uri", 
      rules: [
        { required: false, message: i18n.t('views.skos.schemeCard.broaderConceptHelp') },
        (formInstance) => ({
          message: i18n.t('views.skos.schemeCard.rootOrBroaderRequired'),
          validator: async (_, value) => {
            const hasTopConcept = formInstance.getFieldValue("new.flag.boolean");
            if (!hasTopConcept && (!value || value.length === 0)){
              return Promise.reject(new Error());
             }
            return Promise.resolve();
          },
        }),
        { type: 'url', warningOnly: true }, 
        { type: 'string', min: 6 }
      ],
      "label": i18n.t('views.skos.schemeCard.broader'),
      options:concepts,
      onSelect: (value, event) => {
        //console.log("aaaaaaa", value, event, formRef.current);
        //formRef.current.setFieldValue("new.flag.boolean", value == "");        
      }
    },
    { "uri": "http://www.w3.org/2004/02/skos/core#definition", 
      rules:[{ required: true, message: i18n.t('views.skos.schemeCard.conceptDescriptionRequired') }]
    }
  ];
  const tail = [
  ];
	return (
    <Modal style={{minWidth: "80%"}} open={true} 
        title={i18n.t('skos.concept.new.title')}
        cancelText={i18n.t('skos.concept.new.cancelText')}
        okText={i18n.t('skos.concept.new.okText')} 
        onCancel={onCancelOperation} onOk={onFinishOperation}
        destroyOnHidden>	
        <NewElement 
          formRef={formRef} 
          factory={factory} 
          rdfType={"http://www.w3.org/2004/02/skos/core#Concept"} 
          prefixURI={makeHashLastInURI(schemeURI)}
          extra={extra} 
          tail={tail}
          />
	  </Modal>
  )
}

/** Отобразить карточку концепта в режиме редактирования */
const showEditConcept = (formRef=f=>f, factory, concept, onCloseOperation=f=>f, handlers=f=>f) => {
  //console.log("showEditConcept", concept);
	return <Modal 
      style={{minWidth: 700}} open={true}  
      title={i18n.t('views.skos.schemeCard.editConcept')} cancelText={i18n.t('views.skos.common.close')} onOk={onCloseOperation} onCancel={onCloseOperation}
      cancelButtonProps={{ disabled: true, display: "none" }}
      destroyOnHidden>	
        <ConceptCard factory={factory} wrappedComponentRef={formRef} handlers={(e,t,o)=> handlers(e,t,o)} concept={concept} />
	  </Modal>
};

const showReplacement = (iri, factory,  onFinishOperation=f=>f) => {
	return <ConeptUriReplacement
      open={true}
      onClose={onFinishOperation}
      targetUri={iri}
      graph={settings.catalog.graph.iri}
/>
}

/** Карточка skos:ConceptScheme. Отображаются данные из scheme.
 * обеспечивает загрузку данных по skos:ConceptScheme, так как дочерние компоненты должны используать уже загруженные данные.
 * Так же контролирует отображение в режимах редактирования и перевода.
 * 
 */
class ConceptSchemeCard extends React.Component {
  
  constructor(props, context) {
    super(props, context);
    this.state = {
      loaded: false, 			  //Флаг загрузки, карточки skos:ConceptScheme
      operation: "view",    //Текущая операция над карточкой
      detail: undefined,    //Элемент, для которого требуется получение дополнительной информацией
      concept: undefined,   //IRI текущего выбранного концепта (для редактирования, исключения и т.п.)
      adding: false,        //Флаг, для отображения диалога добавления нового свойства
      newConcept: false,    //Флаг, для отображения диалога добавления нового концепта
      linkConcept: false,   //Флаг, для отображения диалога связи концептов
      unlinkConcept: false, //Флаг, для отоабржения диалога исключения концепта их схемы (не удаления)
      editConcept: false,   //Флаг, для отображения диалога редактирования концепта
      usedConcept: false,   //Флаг, для отображения диалога использования концепта
      exportCard: false,    //Флаг, для отображения диалога c экспортом карточки
      synchronize: false,   //Флаг, для отображения диалога c выгрузкой в другой граф
      usedScheme: false,    //Флаг, для отображения диалога c информацией об использовании справочника
      replacement: false,   //Флаг, для отображения диалога с заменой URI концепта 
      deletingAll: false,
      views: false,         //Загружены представления содержимого актива
      activeKey: undefined, //Номер активной вкладки
      newPredicate: undefined, //Предикат, который выбран диалоге добавления нового свойства
      addedPredicates: [],  //Добавленные предикаты
    }
  }
   
  formRef = React.createRef();
    
  static getDerivedStateFromProps(props, state) {
    if ((decodeIRIParams(props.router)!=props.IRI)||(props.state=="empty") || !props.IRI){
      return {loaded: false, operation: "view", detail: undefined, concept: undefined, adding: false, 
        newPredicate:undefined, newConcept: false, linkConcept: false, unlinkConcept: false, 
        editConcept: false, usedConcept:false, addedPredicates:[], exportCard: false, deletingAll: false,
        synchronize: false, usedScheme: false, replacement: false};
    }
    if ((decodeIRIParams(props.router)==props.IRI)||(props.state=="loaded")){
        return { ...state, loaded: true}
    }
    return null; // Return null to indicate no change to state.
  }

  componentDidMount() {
    const IRI = decodeIRIParams(this.props.router);    
    if (!this.state.loaded && (IRI!=this.props.IRI) || (this.props.state=="empty")){
      Promise.all([
        this.props.onReload(SkosScheme, this.props.catalog, IRI),
        this.props.onReloadViews(ModelViews, IRI),
        this.props.onReloadTaxonomy(SkosScheme, this.props.catalog, IRI),        
        this.props.onInGraph(SkosScheme, IRI)
      ]);
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const IRI = decodeIRIParams(this.props.router);

    //Проверим, что добавленное свойство появилось в списке полученных свойств
    if (prevProps.values !== this.props.values && this.state.addedPredicates.length > 0) {
      const addedPredicates = filterAddedPredicates(
        this.state.addedPredicates,
        this.props.values
      );

      if (addedPredicates.length !== this.state.addedPredicates.length) {
        this.setState({ addedPredicates });
        return;
      }
    };

    if (!this.state.loaded && ((IRI!=this.props.IRI)||(this.props.state=="empty") || !this.props.IRI))
      this.props.onReload(SkosScheme, this.props.catalog, IRI).then( response => {
        this.props.onReloadViews(ModelViews, IRI).then(views => {
          const activeKey = (this.props.location && this.props.location.search && this.props.location.search.indexOf('view=')>0)? "3" : undefined;
          this.setState({views: true, activeKey});
        });
        this.props.onReloadTaxonomy(SkosScheme, this.props.catalog, IRI);
      });
  }

  callbackSelectTab(key) {
    console.log(key);
    this.setState({activeKey: undefined});
  }
  
  onSelectOperation(e, operation) { 
    e.preventDefault();
    const { IRI, values, lang, factory, onDeleteElement, onConceptCountInScheme, router} = this.props;
    if (operation=="delete"){
      //Удалить можно, только если отсутствуют концепты
      onConceptCountInScheme(SkosScheme, IRI)
        .then(response => {
          //console.log("ConceptSchemeCard.js onSelectOperation", IRI, response);
          if (response.count != 0){
            message.warning(i18n.t('views.skos.schemeCard.schemeHasConcepts', { count: response.count }));
            return;
          }
          confirm({ title: i18n.t('views.skos.common.deleteSelected'), content: getNameAsset(values, lang),
            okText: i18n.t('views.skos.common.yes'), okType: 'danger', cancelText: i18n.t('views.skos.common.no'),
            onOk() { 
                onDeleteElement(SkosRepository, IRI)
                .then (result =>{
                    console.log("onDeleteElement", result);
                    message.success(i18n.t('views.skos.schemeCard.recordDeleted'));
                    if (router)
                        router.navigate("/schemes");
                })
            },
            onCancel() {},
          });
        });
      return;
    };
    if (operation == "deleteAll"){
      this.setState({deletingAll: true});
      return;
    }
    //Добавление нового свойства
    if (operation=="add"){
      this.setState({adding: true});
      return;
    };    
    //Добавление нового концепта
    if (operation=="new"){
      this.setState({newConcept: true});
      return;
    };    
    //Добавление нового концепта
    if (operation=="link"){
      this.setState({linkConcept: true});
      return;
    };    
    //Редактирование концепта
    if (operation=="editConcept"){
      this.setState({editConcept: true});
      return;
    };          
    if (operation == "back"){
      if (router)
        router.navigate(
          this.props.getBaseRoutePath
          ? this.props.getBaseRoutePath("schemes") 
          : "/schemes"
        );
      return;
    };
    if (operation == "export"){
      this.setState({exportCard: true});
      return;      
    }
    //Информация об использовании схемы 
    if (operation == "usedScheme"){
      this.setState({usedScheme: true});
      return;      
    }
    //Синхронизация с другим графом
    if (operation == "synchronize"){
      this.setState({synchronize: true});
      return;      
    }    
    this.setState({operation});
  }

  /** Вызывается из диалога AddProperty, при добавлении свойства  */
  onSelectNewProperty(property){
    //console.log("ConceptSchemeCard.js onSelectNewProperty", property);
    this.setState({newPredicate: property});
  };

  /** Слушатели различных действий */
  handlers(e, triplet, operation) {
    const { IRI, catalog, values, lang, onUnlinkElement, onReload, onReloadTaxonomy} = this.props;
    e.preventDefault();
    if (operation== "detail" && this.props.onDetailElement){
      const subjectIRI = triplet?.object?.value;
      if (subjectIRI) {
        const url = `#/subject/${encodeURIComponent(subjectIRI)}`;
        window.open(url, "_blank", "noopener,noreferrer");
      }
      return;      
    };
    //   //В триплете приходит {predicat: {…}, object: {…}}
    //   this.props.onDetailElement(SkosScheme, this.props.catalog, triplet)
    //   .then (result =>{
    //     //console.log("handlers(e, triplet, operation)", result);
    //     this.setState({detail: triplet});
    // });
    if (operation== "delete"){
      const { addedPredicates } = this.state;
      if (addedPredicates.includes(triplet))
        this.setState({addedPredicates: addedPredicates.filter(predicate => predicate != triplet)});
    }
    if (operation== "inScheme" && this.props.onInScheme){
      const subjectIRI = triplet?.IRI?.value;
      if (subjectIRI) {
        const url = `#/subject/${encodeURIComponent(subjectIRI)}`;
        window.open(url, "_blank", "noopener,noreferrer");
      }
      return;      
    };
    //   //В триплете приходит {IRI: {…}, Label: {…}, level: 0, hasBroader: false, children: Array(0), …}
    //   this.props.onInScheme(SkosScheme, this.props.catalog, triplet.IRI.value)
    //   .then (result =>{
    //     //console.log("handlers(e, triplet, operation)", result);
    //     this.setState({detail: {object: triplet.IRI}});
    // });
    if (operation== "deleteConcept"){
      //В триплете приходит {IRI: {…}, Label: {…}, level: 0, hasBroader: false, children: Array(0), …}
      this.props.onRemoveConcept(SkosRepository, triplet.IRI.value)
        .then (result =>{
            message.success(i18n.t('views.skos.schemeCard.conceptDeleted'));
            Promise.all([
              this.props.onReload(SkosScheme, this.props.catalog, this.props.IRI),
              this.props.onReloadTaxonomy(SkosScheme, this.props.catalog, this.props.IRI)
            ]);
        })
        .catch(info => {
          message.error(i18n.t('views.skos.schemeCard.conceptDeleteError'));
        });  
    }

    if (operation== "unlink" && onUnlinkElement)       
      confirm({ title: i18n.t('views.skos.schemeCard.unlinkConcept'), content: getNameAsset(values, lang),
        okText: i18n.t('views.skos.common.yes'), okType: 'danger', cancelText: i18n.t('views.skos.common.no'),
        onOk() { 
          onUnlinkElement(SkosRepository, IRI, triplet.IRI.value)
            .then (result =>{
                message.success(i18n.t('views.skos.schemeCard.conceptUnlinked'));
                Promise.all([
                  onReload(SkosScheme, catalog, IRI),
                  onReloadTaxonomy(SkosScheme, catalog, IRI)
                ]);
            })
            .catch(info => {
              message.error(i18n.t('views.skos.schemeCard.conceptUnlinkError'));
            });  
        },
        onCancel() {},
      });

      //В триплете приходит {predicat: {…}, object: {…}}
      this.props.onInScheme(SkosScheme, this.props.catalog, triplet.IRI.value)
      .then (result =>{
        this.setState({concept: triplet.IRI.value, unlinkConcept: true});
    });
    
    if (operation== "editConcept" && this.props.onDetailElement)       
      //В триплете приходит {predicat: {…}, object: {…}}
      this.props.onInScheme(SkosScheme, this.props.catalog, triplet.IRI.value)
      .then (result =>{
        this.setState({concept: triplet.IRI.value, editConcept: true});
    });
    
    if (operation== "replacement"){
      this.setState({concept: triplet.IRI.value, replacement: true});
      return;
    };
    if (operation== "used"){
      this.setState({concept: triplet.IRI.value, usedConcept: true});      
    };
  };

  cancelOperation(){
    this.setState({detail: undefined, concept: undefined, adding: false, newConcept: false, 
      linkConcept: false, unlinkConcept: false,  editConcept:false, usedConcept:false, exportCard: false,
      synchronize: false, usedScheme: false, replacement: false});
  }

  /** Вызывается при добавлении нового свойства. Данные см. AddProperty.js */
  submitAddProperty() {
    this.setState({detail: undefined, adding: false, operation: "edit"});
    const form  = this.formRef.current;
    form.validateFields()
      .then((values) => {
          const addedPredicates = [ ... this.state.addedPredicates, {object:{state: 'new'}, predicat : {type: 'uri', value: values.predicateIri}}];
          this.setState({detail: undefined, adding: false, operation: "edit", addedPredicates});
      }).catch((errorInfo) => {
        console.log(errorInfo);
      });
  };
  

  /** Запускает добавление нового  элемента и установка связи */
  submitNewOperation() {
    const { IRI, onAddConcept, onInsertURI, onInsertLiteral} = this.props;
    //console.log('ConceptSchemeCard.js submitNewOperation() ', this.formRef);
    const form  = this.formRef.current;      
    form.validateFields()
      .then( values => {
        const concept = (values.IRI.startsWith("http://") || values.IRI.startsWith("https://")) 
          ? values.IRI
          : makeURI(makeHashLastInURI(IRI), values.IRI);      
        //Проверим, что IRI отсутствует
        RdfTriplet.countSubject(concept)
        .then ( response =>{
          const count = getCountValue(response.bindings);
          if (count>0){
            message.error(i18n.t('views.skos.schemeCard.uriExists', { iri: concept }));
            return;
          };
          const label = values["http://www.w3.org/2000/01/rdf-schema#label"];
          const rdfType = values["http://www.w3.org/1999/02/22-rdf-syntax-ns#type"];
          const definition = values["http://www.w3.org/2004/02/skos/core#definition"];
          console.log("ConceptSchemeCard.js submitNewOperation() result2 ", IRI, concept, rdfType, label);
          onAddConcept(SkosRepository, IRI, concept, rdfType, label.text)
            .then (result =>{
              const requests = [];
              if (values["new.flag.boolean"]){
                requests.push(onInsertURI(RdfTriplet, IRI, "http://www.w3.org/2004/02/skos/core#hasTopConcept", concept));
                requests.push(onInsertURI(RdfTriplet, concept, "http://www.w3.org/2004/02/skos/core#topConceptOf", IRI));
              }
              if (values["new.select.uri"])
                requests.push(onInsertURI(RdfTriplet, concept, "http://www.w3.org/2004/02/skos/core#broader", values["new.select.uri"]));
              if (definition && definition != "")
                requests.push(onInsertLiteral(RdfTriplet, concept, "http://www.w3.org/2004/02/skos/core#definition", definition));
              Promise.all(requests)
                .then(result2 => {
                  //console.log("ConceptSchemeCard.js submitNewOperation() result2 ", result2);
                  message.success(i18n.t('skos.concept.message.ok_new'));
                  Promise.all([
                    this.props.onReload(SkosScheme, this.props.catalog, IRI),
                    this.props.onReloadTaxonomy(SkosScheme, this.props.catalog, IRI)
                  ]);
              });
            })
            .catch(info => {
               message.error(i18n.t('skos.concept.message.e_new', {detail: info}));
            });
            this.setState({detail: undefined, adding: false, newConcept: false, linkConcept: false, 
              editConcept: false, usedConcept:false, exportCard: false, replacement: false});
          });
      })
      .catch(info => {
        console.log("ConceptSchemeCard.js submitNewOperation() Received info of form: ", info);
        message.error(i18n.t('components.adms.distribution.message.e_new', {detail: info}));
      });
  };

  /** Выполняет связь концепта со схемой */
  submitLinkInScheme(conceptIRI){
    const { IRI, onLinkConcept } = this.props;
    console.log(this, conceptIRI);
    if (onLinkConcept && conceptIRI)
      onLinkConcept(SkosScheme, IRI, conceptIRI)
        .then(response => {
            this.props.onReload(SkosScheme, this.props.catalog, IRI);
            this.props.onReloadTaxonomy(SkosScheme, this.props.catalog, IRI);
            this.cancelOperation();
        })
        .catch(info => {
          message.error(i18n.t('views.skos.schemeCard.linkConceptError', { error: info }));
        });    
  };

  render() {
    let { loaded, operation, detail, concept, adding, activeKey, newPredicate, addedPredicates, 
      newConcept, linkConcept, unlinkConcept, editConcept, usedConcept, exportCard, deletingAll,
      synchronize, replacement} = this.state;
    const { predicates, values, lang, factory, IRI, vviews, isSignedIn, inGroup, concepts, highlight, router} = this.props;
    const asset_json = {id: IRI};
    //Флаг, что есть представление для отображение содержимого 
    const views = vviews && Array.isArray(vviews.views) && vviews.views.length>0;
    console.log(this); //console.log(lang);
    const assetTitle = AssetTitle(getNameAsset(values, lang));
    return (
      (!loaded ? <LoadingComponent />:
        <span>
          <Row>
            <Col className="asset_title" span={24}>{assetTitle}</Col>
          </Row>
          <Row>
            <Tabs defaultActiveKey="1" activeKey={activeKey} onChange={(key)=>this.callbackSelectTab(key)} type="card">
              <TabPane tab={i18n.t('views.adms.card_tab_card')} key="1">
                <div className="csi_wrapper_content csi_inner_asset" resource={IRI}>
                    <Row>
                        <Col className="asset_title" span={16} style={{"display": "flex"}}>
                          <Tooltip placement="top" title={i18n.t('views.skos.schemeCard.backToSchemes')}>
                            <Button type="dashed" icon={<RollbackOutlined />} onClick={(e)=> this.onSelectOperation(e, "back")}/>
                          </Tooltip>                    
                        </Col>
                        <Col className="asset_title_buttons" span={8} style={{"display": "flex", "flexDirection": "row-reverse"}}>
                          {isSignedIn && inGroup.PowerUser && (
                            <ButtonGroup>
                              <Tooltip placement="top" title={i18n.t('views.skos.export.model')}>
                                <Button icon={<FileZipOutlined />} onClick={(e)=> this.onSelectOperation(e, "export")}/>
                              </Tooltip>                              
                              &nbsp;&nbsp;
                              { operation != "view" && (
                                <>
                                  <Tooltip placement="top" title={i18n.t('views.skos.schemeCard.addConcept')}>
                                    <Button icon={<AppstoreAddOutlined />} onClick={(e)=> this.onSelectOperation(e, "new")}></Button>
                                  </Tooltip>
                                  &nbsp;&nbsp;
                                  <Tooltip placement="top" title={i18n.t('views.skos.schemeCard.linkConcept')}>
                                    <Button icon={<LinkOutlined />} onClick={(e)=> {this.onSelectOperation(e, "link")}} ></Button>
                                  </Tooltip>
                                  &nbsp;&nbsp;
                                  <Tooltip placement="top" title={i18n.t('views.skos.schemeCard.addProperty')}>
                                      <Button icon={<FileAddOutlined />} onClick={(e)=> this.onSelectOperation(e, "add")}/>
                                  </Tooltip>
                                  &nbsp;&nbsp;
                                  <Tooltip placement="top" title={i18n.t('views.skos.schemeCard.deleteSchemeAndConcepts')}>
                                      <Button icon={<DeleteOutlined />} onClick={(e)=> this.onSelectOperation(e, "deleteAll")}/>
                                  </Tooltip>
                                  &nbsp;&nbsp;
                                  <Tooltip placement="top" title={i18n.t('views.skos.schemeCard.viewMode')}>
                                    <Button type="primary" icon={<CreditCardOutlined />} onClick={(e)=> this.onSelectOperation(e, "view")} />
                                  </Tooltip>
                                </>
                              )}
                              {operation!="edit" && operation!="deleteAll" && (
                                <Tooltip placement="top" title={i18n.t('views.skos.schemeCard.editMode')}>
                                    <Button icon={<EditOutlined />} onClick={(e)=> this.onSelectOperation(e, "edit")}/>
                                </Tooltip>
                              )}
                              &nbsp;&nbsp;
                              <Tooltip placement="top" title={i18n.t('views.skos.schemeCard.removeSchemeFromCatalog')}>
                                <Button icon={<CloseOutlined />} onClick={(e)=> this.onSelectOperation(e, "delete")}/>
                              </Tooltip>                              
                            </ButtonGroup>
                          )}
                          {isSignedIn && inGroup.Expert && (
                            <>
                              &nbsp;&nbsp;
                              <Tooltip placement="top" title={i18n.t('views.skos.scheme.used_information')}>
                                <Button disabled icon={<InfoCircleOutlined />} onClick={(e)=> this.onSelectOperation(e, "usedScheme")}></Button>
                              </Tooltip>
                              &nbsp;&nbsp;
                              <Tooltip placement="top" title={i18n.t('views.skos.scheme.synchronize')}>
                                <Button icon={<FileSyncOutlined />} onClick={(e)=> this.onSelectOperation(e, "synchronize")}></Button>
                              </Tooltip>
                              
                            </>
                          )}
                        </Col>
                    </Row>
                    <Row id="ConceptSchemeData">
                        <Col className="assetCardTable" span={16}>
                          <ConceptSchemeData 
                            addedPredicates={addedPredicates} operation={operation} factory={factory} 
                            handlers={(e,t,o)=> this.handlers(e,t,o)} getBaseRoutePath={this.props.getBaseRoutePath} /> 
                          {detail && 
                            showViewDetail(this.formRef, detail, factory, lang, ()=>this.cancelOperation(), ()=>this.cancelOperation())
                          }
                          <ConceptSchemeUsed uris={concepts}/>
                        </Col>
                        <Col className="properties_panel_wrapper" span={8}>
                          <Row>
                            <ConceptsInSchemeCard operation={operation} expand={true} scheme={IRI} factory={factory} 
                              handlers={(e,t,o)=> this.handlers(e,t,o)} highlight={highlight || []}  getBaseRoutePath={this.props.getBaseRoutePath} />
                          </Row>
                        </Col>
        {adding && 
          showAddProperty(this.formRef, IRI, [...predicates, ...addedPredicates], factory, lang, 
            ()=>this.submitAddProperty(), ()=>this.cancelOperation(),
            newPredicate, ({value}) => this.onSelectNewProperty(value)
          )
        }
        {newConcept && showNew( this.formRef, factory, ()=>this.submitNewOperation(), ()=>this.cancelOperation(), IRI, concepts) }
        {linkConcept && showLink(factory, ()=>this.cancelOperation(), ()=>this.cancelOperation(), (uri)=> this.submitLinkInScheme(uri)) }
        {editConcept && showEditConcept( this.formRef, factory, concept, ()=>this.cancelOperation(),  (e,t,o)=> this.handlers(e,t,o))}
        {usedConcept && showUsed(concept, factory, ()=>this.cancelOperation())}        
        {exportCard && <ExportConceptScheme open={true} onClose={()=> this.cancelOperation()} IRI={IRI}/>}
        {synchronize && <SynchronizationConceptScheme open={true} onClose={()=> this.cancelOperation()} IRI={IRI}/>}
        {deletingAll && <DeleteScheme
          open={true}
          uri={IRI}
          onClose={() => this.setState({deletingAll: false})}
          onDeleted={() => {
            message.success(i18n.t('views.skos.schemeCard.schemeDeleted'));
            if (router)
              router.navigate(
                this.props.getBaseRoutePath
                ? this.props.getBaseRoutePath("schemes") 
                : "/schemes"
              );
          }}
        />}
        {replacement && showReplacement(concept, factory, ()=>this.cancelOperation())}
            </Row>
          </div>
        </TabPane>
        {/* {views && (<TabPane tab={i18n.t('views.adms.card_tab_content')} key="3">
            <ViewsProxy rpc_url={ModelViews.getRpc_url()} asset={asset_json} view={view} location={this.props.location}/>
            </TabPane>)
        } */}
      </Tabs>
      </Row>
      </span>
      )
    )
  }
}

export default ConceptSchemeCard;
